export default __webpack_public_path__ + "static/media/eth.8712eea0.svg";